import {
  BookDayPass,
  BookMeetingRoom,
  BuyPackage,
  FreePeriods,
  GetAvailablePackages,
  GetDayPassBookingCost,
  GetFreePeriods,
  GetMeetingRoomBookingCost,
} from './booking.types';

export const getSettings = async (clientName) => {
  try {
    const response = await fetch(`https://${clientName}.pickspace.com/api/app/settings`);
    return response.json();
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const getUnitsByLocationId = async (phpUrl, locationId: string) => {
  try {
    const response = await fetch(`${phpUrl}/external-meetingroom?cmd=getConferenceRooms&locationid=${locationId}`);
    return response.json();
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const getLocationPaymentMethods = async (phpUrl, locationId: string) => {
  try {
    const response = await fetch(`${phpUrl}/external-daypass?cmd=getLocationPaymentMethods&location=${locationId}`);
    return response.json();
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const getAllowedOfficesByLocationId = async (phpUrl, locationId: string, startDate: string, endDate: string) => {
  try {
    let params = `locationId=${locationId}`;
    if (startDate && endDate) {
      params += `&startDate=${startDate}&endDate=${endDate}`;
    }
    const response = await fetch(`${phpUrl}/external-daypass?cmd=getDaypassOffices&${params}`);
    return response.json();
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const getDayPassBookingCost: GetDayPassBookingCost = async (phpUrl, bookingData) => {
  const { locationId, quantity, officeId, startDate, endDate } = bookingData;
  try {
    let params = `locationId=${locationId}&quantity=${quantity}&officeId=${officeId}`;
    if (startDate && endDate) {
      params += `&startDate=${startDate}&endDate=${endDate}`;
    }
    const response = await fetch(`${phpUrl}/external-daypass?cmd=getBookingCost&${params}`);
    return response.json();
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const getMeetingRoomBookingCost: GetMeetingRoomBookingCost = async (phpUrl, bookingData) => {
  const { conferenceRoom, date, fromTime, toTime, discount_code } = bookingData;
  try {
    let url = `${phpUrl}/external-meetingroom?cmd=getBookingCost&fromTime=${fromTime}&toTime=${toTime}&conferenceRoom=${conferenceRoom}&date=${date}`;
    if (discount_code) {
      url += `&discount_code=${encodeURIComponent(discount_code)}`;
    }
    const response = await fetch(url);
    return response.json();
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const getFreePeriods: GetFreePeriods = async (phpUrl, date, conferenceRoomIds) => {
  // promise all and map over all ids to get free periods
  try {
    const promises = conferenceRoomIds.map((conferenceRoomId) =>
      fetch(
        `${phpUrl}/external-meetingroom?cmd=getFreePeriods&conference_roomid=${conferenceRoomId}&booking_date=${date}`,
      ).then((response) => response.json()),
    );

    const responses: FreePeriods[] = await Promise.all(promises);
    return responses;
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const bookMeetingRoomAPICall: BookMeetingRoom = async (phpUrl, data) => {
  try {
    const response = await fetch(`${phpUrl}/external-meetingroom`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      return response;
    }
    throw new Error((await response.json()).message);
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const bookDayPassAPICall: BookDayPass = async (phpUrl, data) => {
  // promise all and map over all ids to get free periods
  try {
    const response = await fetch(`${phpUrl}/external-daypass`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      return response;
    }
    throw new Error((await response.json()).message);
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const buyCreditAPICall: BuyPackage = async (phpUrl, data) => {
  // promise all and map over all ids to get free periods
  try {
    const response = await fetch(
      `${phpUrl}/external-conference-rooms-packages?cmd=submitExternalConferenceRoomsRequest`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          locationId: data.locationId,
          packageId: data.packageId,
          paymentInfo: data.payment_info,
          memberInfo: { ...data.member_info, phone: data.member_info.phonenumber },
        }),
      },
    );
    if (response.ok) {
      return response.json();
    }
    throw new Error((await response.json()).message);
  } catch (error: any) {
    throw new Error(error.message);
  }
};

export const getAvailablePackages: GetAvailablePackages = async (phpUrl, locationId, cmdType) => {
  // promise all and map over all ids to get free periods
  try {
    const response = await fetch(
      `${phpUrl}/external-conference-rooms-packages?cmd=${cmdType}&locationid=${locationId}`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    if (response.ok) {
      return response.json();
    }
    throw new Error((await response.json()).message);
  } catch (error: any) {
    // throw new Error(error.message);
  }
};
